// Identifiers of saved commercial records use the MongoDB ObjectId format:
// the server stores tasks and new establishments under the same identifier.
export function newId(now = Date.now()) {
  const time = Math.floor(now / 1000).toString(16).padStart(8, "0").slice(-8);
  const bytes = new Uint8Array(8);
  crypto.getRandomValues(bytes);
  return time + Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}
